export default "__VITE_ASSET__9c8467d7__"